export default __webpack_public_path__ + "static/media/Sharp Industries.93e6e50d.png";